import format from 'date-fns/format'
import { enUS, ru, cs } from 'date-fns/locale'

export const dateFormat = function (value, f = '', l = 'en') {
  let locale = enUS

  switch (l) {
    case 'en': {
      locale = enUS
      break
    }
    case 'ru': {
      locale = ru
      break
    }
    case 'cs': {
      locale = cs
      break
    }
  }

  return format(value, f, { locale })
}

export const capitalize = function (value) {
  if (!value) return ''
  return value.charAt(0).toUpperCase() + value.slice(1)
}
